import { useTranslation } from "react-i18next";

import Editor from "../../../Editor/Editor";
import sanitize from "../../../V2/sanitize";

const App = (props) => {
  const { t } = useTranslation();

  const onChange = (content, text) => {
    props.onChange({ content, text });
  };

  return props.editable ? (
    <Editor value={props.value} onEditorChange={onChange} />
  ) : (
    // Bug real (auditoría 2026-08-16): dangerouslySetInnerHTML sobre el contenido
    // libre cargado vía el Editor (rich text) sin sanitizar — XSS persistente.
    <div className="p-2" dangerouslySetInnerHTML={{ __html: sanitize(props.value) }} />
  );
};

export default App;
